export const UPDATE_DRAFT_BID_PROFILE = 'UPDATE_DRAFT_BID_PROFILE';
export const UPDATE_DRAFT_BID_PROFILE_OBJECTS = 'UPDATE_DRAFT_BID_PROFILE_OBJECTS';
export const RESET_DRAFT_BID_PROFILE = 'RESET_DRAFT_BID_PROFILE';

/** Bidding info selection */
export const UPDATE_DRAFT_BIDDING_INFORMATION = 'UPDATE_DRAFT_BIDDING_INFORMATION';
export const UPDATE_DRAFT_ORIGINAL_BIDDING_INFORMATION = 'UPDATE_DRAFT_ORIGINAL_BIDDING_INFORMATION';

/** Schedule selection */
export const UPDATE_DRAFT_SCHEDULE_SELECTION = 'UPDATE_DRAFT_SCHEDULE_SELECTION';
export const UPDATE_DRAFT_SCHEDULE_SELECTION_SELECTED_WORKPLAN = 'UPDATE_DRAFT_SCHEDULE_SELECTION_SELECTED_WORKPLAN';
export const CHECK_DRAFT_SCHEDULE_ITEM = 'CHECK_DRAFT_SCHEDULE_ITEM';
export const CHECK_ALL_DRAFT_SCHEDULE_ITEM = 'CHECK_ALL_DRAFT_SCHEDULE_ITEM';
export const CHECK_DRAFT_WORKPLAN_SCHEDULE_ITEM = 'CHECK_DRAFT_WORKPLAN_SCHEDULE_ITEM';
export const CHECK_ALL_DRAFT_WORKPLAN_SCHEDULE_ITEM = 'CHECK_ALL_DRAFT_WORKPLAN_SCHEDULE_ITEM';
export const UPDATE_DRAFT_ORIGINAL_SCHEDULE_SELECTION = 'UPDATE_DRAFT_ORIGINAL_SCHEDULE_SELECTION';

/** Employee selection */
export const UPDATE_DRAFT_EMPLOYEES_SELECTION = 'UPDATE_DRAFT_EMPLOYEES_SELECTION';
export const UPDATE_DRAFT_ORIGINAL_EMPLOYEES_SELECTION = 'UPDATE_DRAFT_ORIGINAL_EMPLOYEES_SELECTION';

/** Schedule periods */
export const UPDATE_DRAFT_BID_PROFILE_SCHEDULE = 'UPDATE_DRAFT_BID_PROFILE_SCHEDULE';
export const UPDATE_DRAFT_ORIGINAL_BID_PROFILE_SCHEDULE = 'UPDATE_DRAFT_ORIGINAL_BID_PROFILE_SCHEDULE';
